var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3969_16463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.58759 7.57687C8.58759 8.27927 8.01817 8.84869 7.31577 8.84869H2.93851C2.23611 8.84869 1.66669 8.27927 1.66669 7.57687V4.4708C1.66669 3.7684 2.23611 3.19897 2.93851 3.19897H7.31573C8.01817 3.19897 8.58759 3.7684 8.58759 4.4708V7.57687Z",
    stroke: "#706F7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 11.5317C18.3334 12.2341 17.7639 12.8035 17.0615 12.8035H12.543C11.8406 12.8035 11.2712 12.2341 11.2712 11.5317V4.4708C11.2712 3.7684 11.8406 3.19897 12.543 3.19897H17.0615C17.7639 3.19897 18.3334 3.7684 18.3334 4.4708V11.5317Z",
    stroke: "#706F7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 18.5938C18.3334 19.2962 17.7639 19.8656 17.0615 19.8656H12.543C11.8406 19.8656 11.2712 19.2962 11.2712 18.5938V16.9002C11.2712 16.1978 11.8406 15.6284 12.543 15.6284H17.0615C17.7639 15.6284 18.3334 16.1978 18.3334 16.9002V18.5938Z",
    stroke: "#706F7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58759 18.5938C8.58759 19.2962 8.01817 19.8656 7.31577 19.8656H2.93851C2.23611 19.8656 1.66669 19.2962 1.66669 18.5938V12.8041C1.66669 12.1017 2.23611 11.5323 2.93851 11.5323H7.31573C8.01817 11.5323 8.58759 12.1017 8.58759 12.8041V18.5938Z",
    stroke: "#706F7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3969_16463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#706F7B",
    transform: "translate(0 0.698975)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardNew);
export default __webpack_public_path__ + "static/media/dashboardNew.4ce161d271c610db63f41f785d1f9f33.svg";
export { ForwardRef as ReactComponent };